import React, { Component } from "react";
import { Link } from "react-router-dom";
// style for page
import "./authentication.css";
// images for page
import LeftPartBg from "../assets/images/register/80a8f0b0-ef84-4333-b37c-214d0a55f9a6.png";
import Logo from "../assets/images/logo.png";
import Loader from "../assets/images/loader.svg";
//request  module
import axios from "axios";
// icon pack
import Ionicon from "react-ionicons";

export default class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      confirmPassword: "",
      emailValid: null,
      emailRegistered: false,
      passwordValid: null,
      confirmPasswordValid: null,
      emailTypeLoader: false,
      passwordTypeLoader: false,
      confirmPasswordTypeLoader: false,
      activeView: 0
    };
    this.buttonActive = null;
    this.emailAlertClass = null;
    this.passAlertClass = null;
    this.confirmPassAlertClass = null;
    this.iconSize = "50px";
    //  on type timer
    this.timer = null;
    this.typeDelay = 700;
  }
  // initiallize settings
  componentDidMount = () => {
    this.refs.email.focus();
    this.buttonActive = false;
  };
  //  on form submit
  handleSubmit = e => {
    e.preventDefault();
    window.location.assign(`/login`);
    
  };
  // change view to argument e
  changeView = e => {
    this.setState({
      activeView: e
    });
  };
  // on field typing
  handleChange = e => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState(
      {
        [name]: value,
        // values for validate
        fieldToValidateName: name,
        fieldToValidateValue: value
      },

      this.timerLoader(name, value)
    );
  };
  // delay on field type,show/hide loader
  timerLoader = (n, v) => {
    // reset timer
    window.clearTimeout(this.timer);
    // turn on loader ,turn off validation
    this.setState({
      [n + "TypeLoader"]: true,
      [n + "Valid"]: null,
      emailRegistered: false
    });
    // turn off loader
    setTimeout(() => {
      this.setState({ [n + "TypeLoader"]: false });
    }, 400);
    // // after delay, callback validation function
    this.timer = setTimeout(() => {
      this.checkValidation(n, v);
    }, this.typeDelay);
  };
  checkDoubleEmail = () => {
    if (this.state.emailRegistered) {
      this.setState({
        emailRegistered: false
      });
    }
  };
  // validate email password fields
  checkValidation = () => {
    let argName = this.state.fieldToValidateName;
    let argValue = this.state.fieldToValidateValue;

    // check email validation
    if (argName === "email") {
      if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(argValue)) {
        this.setState({
          emailValid: false
        });
      } else {
        this.setState(
          {
            emailValid: true
          },
          this.checkDoubleEmail()
        );
      }
    }
    // check password validation
    if (argName === "password") {
      if (argValue.length > 5) {
        this.setState({
          passwordValid: true
        });
      } else {
        this.setState({
          passwordValid: false
        });
      }
    }
    // check confirm password validation
    if (argName === "confirmPassword") {
      if (this.state.password === argValue && argValue.length > 5) {
        this.setState({
          confirmPasswordValid: true
        });
      } else if (this.state.password !== argValue || argValue.length < 5) {
        this.setState({
          confirmPasswordValid: false
        });
      }
    }
  };
  render() {
    // email validation alert
    const emailValidHTML = this.state.emailValid ? (
      <Ionicon
        icon="ios-checkmark"
        fontSize={this.iconSize}
        className="alert"
        color="#36c547"
      />
    ) : (
      <React.Fragment>
        <Ionicon
          icon="ios-close"
          fontSize={this.iconSize}
          className="alert"
          color="#f50c3d"
        />
        <span className="alertText">Enter valid email adress</span>
      </React.Fragment>
    );
    const emailRegistered = (
      <React.Fragment>
        <Ionicon
          icon="ios-close"
          fontSize={this.iconSize}
          className="alert"
          color="#f50c3d"
        />
        <span className="alertText">This email is already registered</span>
      </React.Fragment>
    );
    // password validation alert
    const passwordValidHTML = this.state.passwordValid ? (
      <Ionicon
        icon="ios-checkmark"
        fontSize={this.iconSize}
        className="alert"
        color="#36c547"
      />
    ) : (
      <React.Fragment>
        <Ionicon
          icon="ios-close"
          fontSize={this.iconSize}
          className="alert"
          color="#f50c3d"
        />
        <span className="alertText">{`minimum length 6 characters`}</span>
      </React.Fragment>
    );

    // confirm password validation alert
    const confirmPasswordHTML = this.state.confirmPasswordValid ? (
      <Ionicon
        icon="ios-checkmark"
        fontSize={this.iconSize}
        className="alert"
        color="#36c547"
      />
    ) : (
      <React.Fragment>
        <Ionicon
          icon="ios-close"
          fontSize={this.iconSize}
          className="alert"
          color="#f50c3d"
        />
        <span className="alertText">{`Passwords need to match`}</span>
      </React.Fragment>
    );

    // button state
    if (
      this.state.emailValid &&
      this.state.confirmPasswordValid &&
      this.state.confirmPassword.length > 5
    ) {
      this.buttonActive = true;
    }
    if (!this.state.emailValid || !this.state.confirmPasswordValid) {
      this.buttonActive = false;
    }
    // field alert style
    if (this.state.emailValid !== null) {
      this.state.emailValid
        ? (this.emailAlertClass = "succes")
        : (this.emailAlertClass = "warrning");
    }
    if (this.state.passwordValid !== null) {
      this.state.passwordValid
        ? (this.passAlertClass = "succes")
        : (this.passAlertClass = "warrning");
    }
    if (this.state.confirmPasswordValid !== null) {
      this.state.confirmPasswordValid
        ? (this.confirmPassAlertClass = "succes")
        : (this.confirmPassAlertClass = "warrning");
    }
    let registerForm = (
      <form onSubmit={this.handleSubmit} onChange={this.handleChange}>
        <img src={Logo} />
        <div className="formHeading">Start using JungleProof</div>
        <label className="centered grayTxt">
          Already have an account? &nbsp;
          <Link to="/login" className="btnLink">
            Login here
          </Link>
        </label>
        <label className="labelRelative">
          <input
            type="text"
            placeholder="Email"
            name="email"
            value={this.state.email}
            onChange={this.handleChange}
            onBlur={this.checkValidation}
            ref="email"
            className={this.emailAlertClass}
            required
          />
          {this.state.emailValid !== null && !this.state.emailRegistered
            ? emailValidHTML
            : null}
          {this.state.emailRegistered ? emailRegistered : null}
          {this.state.emailTypeLoader ? (
            <span className="typeLoader">
              <img src={Loader} />
            </span>
          ) : null}
        </label>
        <label className="labelRelative">
          <input
            type="password"
            placeholder="Password"
            name="password"
            value={this.state.password}
            onChange={this.handleChange}
            onBlur={this.checkValidation}
            className={this.passAlertClass}
            ref="pass"
            required
          />
          {this.state.passwordValid !== null ? passwordValidHTML : null}
          {this.state.passwordTypeLoader ? (
            <span className="typeLoader">
              <img src={Loader} />
            </span>
          ) : null}
        </label>
        <label className="labelRelative">
          <input
            type="password"
            placeholder="Confirm Password"
            value={this.state.confirmPassword}
            onChange={this.handleChange}
            name="confirmPassword"
            className={this.confirmPassAlertClass}
            ref="cPass"
            required
          />
          {this.state.confirmPasswordValid !== null
            ? confirmPasswordHTML
            : null}
          {this.state.confirmPasswordTypeLoader ? (
            <span className="typeLoader">
              <img src={Loader} />
            </span>
          ) : null}
        </label>
        {this.state.emailRegistered ? (
          <label className="authMessage">
            Please try to register with another email or &nbsp;
            <Link to="/login">Log in</Link>
          </label>
        ) : null}

        <button
          className="buttonMid"
          type="submit"
          disabled={!this.buttonActive}
        >
          <span>CREATE AN ACCOUNT</span>
        </button>
        <label className="centered grayTxt bottomLabel">
          By clicking “Register”, I agree to JungleProof’s &nbsp;
          <Link to="/" className="btnLink">
            Terms of Service
          </Link>
        </label>
      </form>
    );
    const registerSucces = (
      <React.Fragment>
        <img src={Logo} />
        <div className="formHeading">
          We sent confirm link,
          <br /> Check your mail
        </div>
        <label className="centered grayTxt">
          Go to &nbsp;
          <Link to="/" className="btnLink">
            main page
          </Link>
        </label>
      </React.Fragment>
    );
    const emailError = (
      <React.Fragment>
        <img src={Logo} />
        <div className="formHeading">This email has already registred</div>
        <label className="centered grayTxt">
          {/* Go to &nbsp;
          <Link to="/" className="btnLink">
            main page
          </Link>
          &nbsp; */}
          <Link to="/reset" className="btnLink">
            reset password
          </Link>
        </label>
        <label className="centered grayTxt" />
      </React.Fragment>
    );

    let pageToRend = null;
    switch (this.state.activeView) {
      case 0:
        pageToRend = registerForm;
        break;
      case 1:
        pageToRend = registerSucces;
        break;
      default:
        pageToRend = <h1>Something went wrong</h1>;
    }
    return (
      <React.Fragment>
        <div className="authPage">
          <div className="leftPart grayBg">
            <img src={LeftPartBg} />
          </div>
          <div className="rightPart">
            <div className="Form perfectCenter">{pageToRend}</div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
